import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { PayrollConceptSelectFieldFragment } from 'generated/resources/graphql'

import { translations as roleLevelSalaryTranslations } from 'modules/contracts/components/FixFlow/lib/roleLevelSalaryTranslations'
import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import { useCrudDisclosure } from 'modules/contracts/hooks/useCrudDisclosure'
import { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'
import { translate } from 'modules/contracts/lib/translate'

import { AdditionalCompensationsList } from './AdditionalCompensationsList/AdditionalCompensationsList'
import {
  CreateAdditionalCompensationFormModal,
  CreateAdditionalCompensationWizardModal,
} from './CreateAdditionalCompensation'
import { DeleteAdditionalCompensation } from './DeleteAdditionalCompensation'
import {
  EditAdditionalCompensationFormModal,
  EditAdditionalCompensationWizardModal,
} from './EditAdditionalCompensation'

type AdditionalCompensationListProps = {
  additionalCompensations: InMemoryAdditionalCompensation[]
  type: ContractFlowType
  payrollConcepts: PayrollConceptSelectFieldFragment[]
  effectiveOn?: string
  contractVersionId: string
  isPerWorkedDayFeatureEnabled?: boolean
}

function ContractAdditionalCompensationList({
  additionalCompensations,
  payrollConcepts,
  effectiveOn,
  contractVersionId,
  isPerWorkedDayFeatureEnabled = false,
}: AdditionalCompensationListProps) {
  const {
    isEditing,
    onEdit,
    onClose,
    editValue,
    isCreating,
    onCreate,
    isDeleting,
    deleteValue,
    onDelete,
  } = useCrudDisclosure<InMemoryAdditionalCompensation>()
  const translations = roleLevelSalaryTranslations()

  return additionalCompensations ? (
    <Box gap="s24">
      <Button onClick={onCreate} iconName="add">
        {translate(translations, 'add_compensation')}
      </Button>
      <AdditionalCompensationsList
        additionalCompensations={additionalCompensations}
        onEdit={onEdit}
        onDelete={onDelete}
      />

      {isEditing && editValue ? (
        isPerWorkedDayFeatureEnabled ? (
          <EditAdditionalCompensationWizardModal
            onClose={onClose}
            additionalCompensation={editValue}
            payrollConcepts={payrollConcepts}
            effectiveOn={effectiveOn}
          />
        ) : (
          <EditAdditionalCompensationFormModal
            onClose={onClose}
            additionalCompensation={editValue}
            payrollConcepts={payrollConcepts}
            effectiveOn={effectiveOn}
          />
        )
      ) : (
        isCreating && (
          <>
            {isPerWorkedDayFeatureEnabled ? (
              <CreateAdditionalCompensationWizardModal
                onClose={onClose}
                payrollConcepts={payrollConcepts}
                effectiveOn={effectiveOn}
                contractVersionId={contractVersionId}
              />
            ) : (
              <CreateAdditionalCompensationFormModal
                onClose={onClose}
                payrollConcepts={payrollConcepts}
                effectiveOn={effectiveOn}
                contractVersionId={contractVersionId}
              />
            )}
          </>
        )
      )}

      {isDeleting && deleteValue && (
        <DeleteAdditionalCompensation additionalCompensation={deleteValue} onClose={onClose} />
      )}
    </Box>
  ) : null
}

export { ContractAdditionalCompensationList }
